<template>
  <div id="lead-filter">
    <div
      class="nav-button"
      @click="toggle"
    >
      <img
        alt="img-size-24"
        src="../../assets/img/leads/filter-white.png"
        class="img-size-24"
      >
      <div
        class="white-f-16"
      >
        All Filters
      </div>
    </div>
    <div
      v-for="(filter, idx) in serviceFilters"
      :key="idx"
    >
      <SACFilterOption
        :item="filter"
        :change="updateFilter"
        :clear="clearFilter"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import SACFilterOption from '@shared/components/sac/SACFilterOption';
import { mapState } from 'vuex';

export default {
  name: 'ServiceFilters',
  components: {
    SACFilterOption,
  },
  props: {
    loading: Boolean,
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    toggle: Function,
    loadData: Function,
  },
  computed: {
    ...mapState({
      activeTab: (state) => state.service.activeTab,
    }),
    serviceFilters() {
      if (!this.filters || !this.filters.length) {
        return [];
      }
      return this.filters.filter((filter) => {
        const { key } = filter;
        if (filter.showOnMain) {
          if (this.activeTab === 'pending') {
            return ['sortBy', 'unitAge', 'distance', 'lastOccurrence', 'statusPendingTab', 'leadType'].includes(key);
          }
          if (this.activeTab === 'scheduled') {
            return ['sortBy', 'unitAge', 'serviceType', 'techs'].includes(key);
          }
          if (this.activeTab === 'closed') {
            return ['sortBy', 'statusClosedTab', 'unitAge', 'distance', 'dateCreated', 'techs'].includes(key);
          }
          if (this.activeTab === 'snoozed') {
            return ['sortBy', 'unitAge'].includes(key);
          }
          if (this.activeTab === 'incomplete') {
            return ['sortBy', 'unitAge', 'dateCreated'].includes(key);
          }
          return true;
        }
        return false;
      });
    },
  },
  methods: {
    updateFilter(option, key) {
      const newFilters = this.filters.map((op) => {
        const filter = { ...op };
        if (key === 'leadType' && filter.key === key) {
          filter.active = true;
          filter.activeOption = [option];
        } else if (filter.key === key) {
          filter.active = true;
          filter.activeOption = option;
        }
        return filter;
      });
      this.$store.dispatch('changeServiceValues', [{
        field: 'serviceFilters',
        value: newFilters,
      }]);
      this.loadData();
    },
    clearFilter(key) {
      const newFilters = this.filters.map((op) => {
        const filter = { ...op };
        if (key === 'leadType' && filter.key === key) {
          filter.active = false;
          filter.activeOption = [];
        } else if (filter.key === key) {
          filter.active = false;
          filter.activeOption = {};
        }
        return filter;
      });
      this.$store.dispatch('changeServiceValues', [{
        field: 'serviceFilters',
        value: newFilters,
      }]);

      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
#lead-filter {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: sticky;
  top: 60px;
  gap: 10px;
  font-size: 0.85em;
  .nav-button {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 44px;
    padding: 0 12px;
    border-radius: 6px;
    background-color: $N95;
    cursor: pointer;
    &.active {
      background-color: $NBLUE110;
      border-radius: 6px;
    }
    &:hover {
      background-color: $N90;
      border-radius: 6px;
    }
  }
}
</style>
